var showAfter = 1800;
var popup = $('#popupModal');
var date = new Date();
date.setDate(date.getDate() + 7);


$(document).ready(function () {

    var popupCookieSet = document.cookie.split(';').filter(function (item) {
        return item.trim().indexOf('popup_seen=') == 0
    }).length;

    if (popupCookieSet == 0) {
        document.cookie = 'popup_seen=false; expires=Thu, 31 Dec 2099 23:59:59 UTC; path=/';
    }

    var approved = getUrlVars()["success"];
    if (approved == 1) {
        document.cookie = 'popup_seen=true; expires=Thu, 31 Dec 2099 23:59:59 UTC; path=/';
    }
});

/*$(document).on('scroll resize', function () {


    if (showAfter < $(document).scrollTop()) {
        if (!popup.hasClass('show')) {
            var popupSeen = document.cookie.split(';').filter(function (item) {
                return item.indexOf('popup_seen=true') >= 0
            }).length;

            if (popupSeen == 0) {
                popup.modal('show');
            }


        }
    }



});*/

setTimeout(function(){
    if (!popup.hasClass('show')) {
        var popupSeen = document.cookie.split(';').filter(function (item) {
            return item.indexOf('popup_seen=true') >= 0
        }).length;

        if (popupSeen == 0) {
            popup.modal('show');
        }
    }
},2000);

popup.on('hidden.bs.modal', function () {
    document.cookie = 'popup_seen=true; expires=' + date + '; path=/';
});

popup.find('.btn-success').on('click', function(){
    document.cookie = 'popup_seen=true; expires=' + date + '; path=/';
});


// WEBPACK FOOTER //
// ./src/js/popup.js